import React from 'react';

export const WeatherSkeleton: React.FC = () => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 animate-pulse">
      {/* Title skeleton */}
      <div className="h-5 bg-blue-200 rounded w-1/3 mb-3"></div>
      
      {/* Content skeleton */}
      <div className="space-y-2">
        <div className="h-4 bg-blue-200 rounded w-full"></div>
        <div className="h-4 bg-blue-200 rounded w-3/4"></div>
      </div>
      
      {/* Temperature badges skeleton */}
      <div className="flex gap-2 mt-3">
        <div className="h-6 bg-blue-200 rounded w-16"></div>
        <div className="h-6 bg-blue-200 rounded w-20"></div>
      </div>
    </div>
  );
};

